import { Navigate } from "react-router-dom";

// ─── Per-system route slices ──────────────────────────────────────────────────
import { authPublicRoutes } from "./Components/AuthRoutes";
import { coreRoutes } from "./Components/CoreRoutes";

import { assetGuardRoutes } from "./Components/AssetGuardRoutes";
import { dmsRoutes } from "./Components/DMSRoutes";
import { fleetGuardRoutes } from "./Components/FleetGuardRoutes";
import { fmsRoutes } from "./Components/FMSRoutes";
import { hrisRoutes } from "./Components/HRISRoutes";
import { payrollRoutes } from "./Components/PayrollRoutes";
import { procurementRoutes } from "./Components/ProcurementRoutes";

// ─── Assembled route tables ───────────────────────────────────────────────────
export var authProtectedRoutes = [
    ...coreRoutes,

    ...assetGuardRoutes,
    ...dmsRoutes,
    ...fleetGuardRoutes,
    ...fmsRoutes,
    ...hrisRoutes,
    ...payrollRoutes,
    ...procurementRoutes,

    // Catch-alls — must stay last
    { path: "/", exact: true, component: <Navigate to="/hris/dashboards/employee" /> },
    { path: "*", component: <Navigate to="/coming-soon" /> },
];

export var publicRoutes = [
    ...authPublicRoutes,
];